import { normalizeLocationText } from "../location/locationSearch.ts";

const GENERIC_LOCATION_VALUES = new Set([
  "poloha urcena z mapy",
  "poloha z mapy",
  "poloha podla mapy",
  "lokalita neurcena",
  "lokalita neuvedena",
  "neuvedene",
  "nezname"
]);

export const cleanMarketLocationLabel = (value?: string) => (value ?? "")
  .replace(/(?:^|[\s,])\d{3}\s?\d{2}(?=$|[\s,])/g, " ")
  .replace(/\s*,\s*/g, ", ")
  .replace(/^,\s*|,\s*$/g, "")
  .replace(/\s+/g, " ")
  .trim();

export const isMeaningfulMarketLocation = (value?: string, city?: string) => {
  const normalized = normalizeLocationText(cleanMarketLocationLabel(value));
  if (!normalized || GENERIC_LOCATION_VALUES.has(normalized)) return false;
  if (/^(?:okres|kraj|region|slovensko|slovenska republika)\b/.test(normalized)) return false;
  return !city || normalized !== normalizeLocationText(city);
};

export const extractMeaningfulMarketLocality = (value?: string, municipality?: string) => {
  const municipalityNormalized = normalizeLocationText(municipality ?? "");
  const parts = cleanMarketLocationLabel(value)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
    .filter((part) => !municipalityNormalized || normalizeLocationText(part) !== municipalityNormalized)
    .filter((part) => isMeaningfulMarketLocation(part, municipality));
  return parts.join(", ");
};

type ComparableIdentityInput = {
  city: string;
  street?: string;
  locality?: string;
  propertyType?: string;
  rooms?: string | number;
};

const propertyContext = ({ city, propertyType, rooms }: ComparableIdentityInput) => {
  const type = (propertyType || "Nehnuteľnosť").toLocaleLowerCase("sk");
  const roomLabel = rooms ? `${rooms} ` : "";
  return `${roomLabel}${type} · ${city}`;
};

export const comparableDisplayIdentity = (input: ComparableIdentityInput) => {
  const street = isMeaningfulMarketLocation(input.street, input.city) ? cleanMarketLocationLabel(input.street) : "";
  const locality = isMeaningfulMarketLocation(input.locality, input.city) ? cleanMarketLocationLabel(input.locality) : "";
  const fallback = propertyContext(input);
  if (street) {
    return {
      title: street,
      subtitle: locality && normalizeLocationText(locality) !== normalizeLocationText(street) ? locality : fallback
    };
  }
  if (locality) return { title: locality, subtitle: fallback };
  return { title: fallback, subtitle: "Lokalita v exporte nebola bližšie určená" };
};
